import React from 'react';
import CollapsingList from './collapsing_list';
import { SelectFacetOption } from './select_facet_option';
import { filterID, FilterProps, WidgetType } from './search_filters';
import { RCTooltip } from '../rc/RCTooltip';
import classNames from 'classnames';
import I18n from 'i18n-js';

const COLLAPSE_THRESHOLD = 7;

function FilterName({ name, isTotalPrice }) {
  if (isTotalPrice) {
    return (
      <RCTooltip
        text={I18n.t('commons.totalPrice.tooltip')}
        type="icon"
        placement="top"
      >
        {name}
      </RCTooltip>
    );
  }

  return name;
}

export default function SelectFacet({ filter, pageSection, trackingQuery }: FilterProps) {
  const labelId = `${pageSection}--${filterID(filter)}-lbl`;

  const isTotalPrice = filter.key === 'TOTAL_PRICE';
  const classes = classNames(
    'facet',
    { 'd-none mobile-d-block': isTotalPrice && pageSection === 'sidebar' },
  );

  return (
    <div
      aria-labelledby={labelId}
      className={classes}
      role="group"
    >
      <h3
        id={labelId}
        className="facet__heading"
      >
        <FilterName name={filter.name} isTotalPrice={isTotalPrice} />
      </h3>
      <CollapsingList
        countThreshold={filter.aggregationName === 'TRAITS' ? 3 : COLLAPSE_THRESHOLD}
      >
        {filter.options.map((option, idx) => (
          <SelectFacetOption
            key={idx}
            option={option}
            checkbox={filter.widgetType === WidgetType.CHECKBOX}
            trackingQuery={trackingQuery}
          />
        ))}
      </CollapsingList>
    </div>
  );
}
